<template>
    <div
        class="custom-select item-menu"
        :tabindex="0"
        @blur="open = false"
    >
        <div
            ref="selectTop"
            class="selected active"
            :class="{ 'open': open }"
            :style="{ 'width': selectWidth + 'px'}"
            @click="openDropdown()"
        >
            <v-img
                v-if="type === 'hotspot'"
                :class="{ 'ml-3': $vuetify.breakpoint.smAndUp && $vuetify.breakpoint.width > 750 }"
                :src="hotspotImg"
                max-width="15"
                contain
            />
            <v-icon
                v-else-if="selectedItem"
                class="icon"
                :class="`icon-${selectedItem.id}`"
            />
            <span
                v-if="selectedItem"
                class="nav-text nav-title"
            >
                {{ type === 'hotspot' ? selectedItem.name : selectedItem.text }}
            </span>
            <span
                ref="arrow"
                class="arrow-icon"
                :class="{ 'open': open }"
            >
                <span class="left-bar"/>
                <span class="right-bar"/>
            </span>
        </div>
        <transition name="slidedown">
            <div
                v-show="open"
                ref="selectBot"
                class="items"
                :style="{ 'width': selectWidth + 'px' }"
            >
                <v-row
                    dense
                    class="item"
                    v-for="(item, index) of filteredItems"
                    :key="`item-${index}`"
                    @click="selectItem(item)"
                >
                    <v-col cols="2">
                        <v-img
                            v-if="type === 'hotspot'"
                            :src="hotspotImg"
                            class="ml-2 mt-4"
                            max-width="15"
                            contain
                        />

                        <v-icon
                            v-else
                            class="icon"
                            :class="`icon-${item.id}`"
                        />
                    </v-col>
                    <v-col
                        cols="10"
                        class="item-text"
                    >
                        <span class="nav-text habiteo-body-2 py-2">
                            {{ type === 'hotspot' ? item.name : item.text }}
                        </span>
                    </v-col>
                </v-row>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'AlternativeDropdown',
        props: {
            selectedItem: {
                type: Object
            },
            items: {
                type: Array,
                required: true
            },
            backButton: {
                type: Boolean,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },
        data: () => ({
            open: false,
            selectWidth: null,
            hotspotImg: require('@/assets/images/sidebar-color-pin.png'),
            minWidth: 250
        }),
        computed: {
            filteredItems() {
                return this.$props.selectedItem ? this.$props.items.filter(item => item.id !== this.$props.selectedItem.id) : this.$props.items;
            }
        },
        methods: {
            moveSelected() {
                if (this.$props.backButton) {
                    this.$refs.selectTop.style.marginRight = '92px'
                    this.$refs.selectBot.style.marginRight = '92px'
                    this.$refs.arrow.style.marginRight = '92px'
                    let mobile = window.matchMedia("(max-width: 700px)");
                    if (mobile.matches) {
                        this.$refs.selectTop.style.marginRight = '0px'
                        this.$refs.selectBot.style.marginRight = '0px'
                        this.$refs.arrow.style.marginRight = '0px'
                    }
                }
            },
            getMaxWidth() {
                this.$refs.selectBot.style.display = 'block';
                let topWidth = this.$refs.selectTop.clientWidth;
                let botWidth = this.$refs.selectBot.clientWidth;
                this.$refs.selectBot.style.display = 'none';
                this.selectWidth = topWidth > botWidth ? topWidth : botWidth;
                this.selectWidth = this.selectWidth < this.minWidth ? this.minWidth : this.selectWidth;
            },
            selectItem(item) {
                this.open = false;
                this.$emit('select-item', item);
            },
            openDropdown() {
                if (this.$props.items.length >= 1)
                    this.open = !this.open
            }
        },
        watch: {
            data() {
                this.$nextTick(() => {
                    this.getMaxWidth();
                    this.moveSelected();
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/navbarLayout/alternativeMenu/components/AlternativeDropdown.vue